import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@/app/store'

type SlideStateTYPE = {
  index: number
  path: string
  check: string
  watchid: number
  currentposition: boolean
}

const initialState: SlideStateTYPE = {
  index: 0,
  path: '',
  check: 'map',
  watchid: 0,
  currentposition: false,
}

const slideReducer = createSlice({
  name: 'slideIndex',
  initialState: initialState,
  reducers: {
    slideState(state, action) {
      state.index = action.payload - 1
    },
    spotState(state, action) {
      state.path = action.payload
    },
    spotCheck(state, action) {
      state.check = action.payload
    },
    spotWatchid(state, action) {
      state.watchid = action.payload
    },
    spotCurrentPosition(state, action) {
      state.currentposition = action.payload
    },
  },
})

export const {
  slideState,
  spotState,
  spotCheck,
  spotWatchid,
  spotCurrentPosition,
} = slideReducer.actions

export const selectOsakaPlace = (state: RootState) => state.slideIndex.index
export const selectPath = (state: RootState) => state.slideIndex.path
export const selectCheck = (state: RootState) => state.slideIndex.check
export const selectWatchid = (state: RootState) => state.slideIndex.watchid
export const selectCurrentPosition = (state: RootState) =>
  state.slideIndex.currentposition

export default slideReducer.reducer
